import { Routes } from '@angular/router';
import { NotFoundComponent } from './not-found/not-found.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'client/home',
    pathMatch: 'full'
  },
  {
    path: 'auth/callback',
    loadComponent: () => import('./auth-callback/auth-callback.component')
      .then(m => m.AuthCallbackComponent)
  },
  {
    path: 'auth/embed-login',
    loadComponent: () => import('./auth-embed-login/auth-embed-login.component')
      .then(m => m.AuthEmbedLoginComponent)
  },
  {
    path: 'auth/popup-done',
    loadComponent: () => import('./auth-local/popup-done.component')
      .then(m => m.PopupDoneComponent)
  },
  {
    path: 'auth/login',
    loadComponent: () => import('./auth-local/login.component')
      .then(m => m.LocalLoginComponent)
  },
  {
    path: 'auth/forgot-password',
    loadComponent: () => import('./auth-local/forgot-password.component')
      .then(m => m.ForgotPasswordComponent)
  },
  {
    path: 'auth/set-password',
    loadComponent: () => import('./auth-local/set-password.component')
      .then(m => m.SetPasswordComponent)
  },
  {
    path: 'session-timeout',
    loadChildren: () => import('./+session-timeout-page/session-timeout-page.routes')
      .then(m => m.SESSION_TIMEOUT_ROUTES)
  },
  {
    path: 'client',
    loadChildren: () => import('./+client-admin/client-admin.routes')
      .then(m => m.CLIENT_ADMIN_ROUTES)
  },
  {
    path: 'admin',
    loadChildren: () => import('./+global-admin/global-admin.routes')
      .then(m => m.GLOBAL_ADMIN_ROUTES)
  },
  {
    path: 's/:id',
    loadComponent: () => import('./+story-viewer/single-story')
      .then(m => m.SingleStory)
  },
  {
    path: 's/:id/:slug',
    loadComponent: () => import('./+story-viewer/single-story')
      .then(m => m.SingleStory)
  },
  {
    path: 'mobile',
    loadChildren: () => import('./+mobile-prompt/mobile-prompt.routes')
      .then(m => m.MOBILE_PROMPT_ROUTES)
  },
  {
    // also provide short URL aliases for mobile prompts:
    path: 'r/:id',
    redirectTo: 'mobile/respond-prompt/:id',
  },
  {
    path: 'logout',
    loadComponent: () => import('./logout/logout.component')
      .then(m => m.LogoutComponent)
  },
  {
    path: 'logged-out',
    loadComponent: () => import('./logged-out/logged-out.component')
      .then(m => m.LoggedOutComponent)
  },
  {
    path: 'access-denied',
    loadComponent: () => import('./access-denied/access-denied.component')
      .then(m => m.AccessDeniedComponent)
  },
  {
    path: 'sso-chooser',
    loadComponent: () => import('./sso-chooser/sso-chooser.component')
      .then(m => m.SsoChooserComponent)
  },
  {
    path: '**',
    component: NotFoundComponent
  }
];





